import { ITramoSalida } from '../../core/interfaces/sections.interface';

export class GetAllSectionsAction {
  static readonly type = '[Section] Get All';
  constructor() {}
}

export class AddSectionsAction {
  static readonly type = '[Section] Add New Tramo';
  constructor(public payload: ITramoSalida) {}
}

export class UpdatedSectionsAction {
  static readonly type = '[Section] Updated Tramo';
  constructor(public payload: ITramoSalida) {}
}

export class DeleteSectionsAction {
  static readonly type = '[Section] Delete';
  constructor(public payload: string) {}
}
